import script from "./QHeaderUser.vue?vue&type=script&setup=true&lang=js"
export * from "./QHeaderUser.vue?vue&type=script&setup=true&lang=js"

import "./QHeaderUser.vue?vue&type=style&index=0&id=63524236&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63524236"]])

export default __exports__